import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { Button, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { MyDocument } from './DocumentBooking';

const ModalPrint: React.FC<any> = ({
  okText,
  cancelText,
  listBooking,
  modalOpen,
  onCancel,
  onOk,
  group,
  searchDateBooking,
  listDataBookingPrint,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);

  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const modalHandleOk = () => {
    onOk();
  };

  const modalHandleCancel = () => {
    onCancel();
  };
  return (
    <Modal
      closeIcon={false}
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      cancelText={cancelText}
      okText={okText}
      footer={[]}
      width={1000}
      className="modal-print"
      maskClosable={false}
    >
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <PDFViewer height={700} style={{ width: '100%' }}>
          <MyDocument
            listBooking={listBooking}
            group={group}
            loading={!listBooking?.schedule?.id}
            searchDateBooking={searchDateBooking}
            listDataBookingPrint={listDataBookingPrint}
          />
        </PDFViewer>
      </div>
      <Row className="d-flex justify-content-end mt-3" style={{ paddingBottom: '16px' }}>
        <Button key="cancel" className=" w-160 h-btn-48 me-3 btn-back agent" onClick={() => modalHandleCancel()}>
          Trở lại
        </Button>
        <PDFDownloadLink
          document={
            <MyDocument
              listBooking={listBooking}
              group={group}
              loading={!listBooking?.schedule?.id}
              searchDateBooking={searchDateBooking}
              listDataBookingPrint={listDataBookingPrint}
            />
          }
          fileName={`Thông tin đặt vé ${listBooking?.schedule?.route?.depart_point} - ${listBooking?.schedule?.route?.arrive_point}`}
        >
          <Button
            key="ok"
            type="primary"
            className="w-160 h-btn-48 btn-success"
            htmlType="submit"
            onClick={() => modalHandleOk()}
          >
            Tải xuống
          </Button>
        </PDFDownloadLink>
      </Row>
    </Modal>
  );
};

export default ModalPrint;
